var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v_main_layout v-is-main g-flex g-flex-column"},[_c('router-view',{staticClass:"v-main-container"}),_c('footer-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }